<template>
  <Modal
    sheetbelowsm
    close-button
    :title="title"
    :primary-button="$t('save')"
    :secondary-button="$t('cancel')"
    :primary-button-disabled="!isIntentNameValid || !value || loading"
    :primary-button-loading="loading"
    @primary="onSaveClicked"
    @secondary="onCancelClicked"
    @close="onCancelClicked"
  >
    <div class="sm:w-600">
      <div class="w-full flex flex-col justify-start mt-5 px-10">
        <label class="block text-13 mb-1">{{ $t('projects.secrets.name') }}</label>
        <Input ref="name" v-model="name" class="w-full" :readonly="mode === 'Edit'" />
        <p v-if="nameError.length" class="text-red-600 text-14 text-left pt-2 pl-5 italic">{{ nameError }}</p>
      </div>
      <div class="w-full flex flex-col justify-start mt-5 px-10">
        <label class="block text-13 mb-1">{{ $t('value') }}</label>
        <Input v-model="value" class="w-full" />
      </div>
      <div v-if="errors.length" class="px-10 pt-3 pb-7 text-red-500">
        <ul class="text-13 list-disc pl-4">
          <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
        </ul>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'CreateProjectSecret',
  props: {
    secretName: String,
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mode: 'Add',
      originalName: '',
      name: '',
      nameError: '',
      value: '',
      errors: [],
      loading: false,
    };
  },
  computed: {
    ...mapState(['projectData']),
    ...mapGetters(['getProjectSecrets']),
    title() {
      return this.mode === 'Add' ? this.$t('projects.secrets.add') : this.$t('projects.secrets.edit');
    },
    secrets() {
      return Object.keys(this.getProjectSecrets());
    },
    isIntentNameValid() {
      if (this.name === '') return false;
      if (this.mode === 'Edit' && this.name !== this.originalName) {
        if (this.secrets.includes(this.name)) {
          return false;
        }
      }
      if (this.mode === 'Add') {
        if (this.secrets.includes(this.name)) {
          return false;
        }
      }
      return true;
    },
  },
  mounted() {
    // this.$refs.name.$el.focus();
  },
  methods: {
    ...mapActions(['showToastMessage', 'createProjectSecret', 'updateProjectSecret']),
    validate() {
      this.errors = [];

      if (!this.isIntentNameValid) {
        this.errors.push('The Secret name is invalid!');
      }

      return !this.errors.length;
    },
    onCancelClicked() {
      this.$emit('close');
    },
    async onSaveClicked() {
      if (this.validate()) {
        this.loading = true;
        if (this.mode === 'Add') {
          const response = await this.createProjectSecret({
            name: this.name,
            project_id: this.projectId,
            value: this.value,
          });
          if (response) {
            this.$emit('save', response);
            this.$emit('close');
          }
        }
        if (this.mode === 'Edit') {
          const response = await this.updateProjectSecret({
            name: this.name,
            project_id: this.projectId,
            value: this.value,
          });
          if (response) {
            this.$emit('save', response);
            this.$emit('close');
          }
        }
        this.loading = false;
      }
    },
  },
  created() {
    if (this.secretName && this.secretName.length) {
      this.mode = 'Edit';
      this.originalName = this.secretName;
      this.name = this.secretName;
    } else {
      this.mode = 'Add';
      this.originalName = '';
      this.name = '';
    }
  },
};
</script>
